import { render, staticRenderFns } from "./myAddress.vue?vue&type=template&id=500f1010&"
import script from "./myAddress.vue?vue&type=script&lang=js&"
export * from "./myAddress.vue?vue&type=script&lang=js&"
import style0 from "./myAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports